module.exports = __webpack_public_path__ + "static/media/img_2.7e0c4a18.png";